import axios from "axios";
import { api } from "./api_route";
import { message } from "antd";

export const createCaseTagsAPI = async (caseTagsData) => {
  try {
    const config = {};
    if (typeof FormData !== "undefined" && caseTagsData instanceof FormData) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.post(
      `${api}/caseTags/create`,
      caseTagsData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const getCaseTagsAPI = async (values) => {
  try {
    const response = await axios.get(`${api}/caseTags/case`, {
      params: { organizationID: values.organizationID },
    });
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const updateCaseTagsAPI = async (caseTags_ID, caseTagsData) => {
  try {
    const config = {};
    if (typeof FormData !== "undefined" && caseTagsData instanceof FormData) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.put(
      `${api}/caseTags/update/${caseTags_ID}`,
      caseTagsData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const CheckCaseTagswithCaseDetailsAPI = async (caseTags_ID) => {
  try {
    const response = await axios.delete(
      `${api}/caseTags/delete/check/${caseTags_ID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
      message: response.data?.message,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const deleteCaseTagsAPI = async (caseTags_ID) => {
  try {
    const response = await axios.delete(
      `${api}/caseTags/delete/${caseTags_ID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
      message: response.data?.message,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const bulkAddOrRemoveCaseTagsAPI = async (
  caseNectNumbers,
  caseTagIds,
  action,
) => {
  try {
    const config = {};
    if (typeof FormData !== "undefined" && caseTagIds instanceof FormData) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.post(
      `${api}/caseTags/bulk-modify`,
      { caseNectNumbers, caseTagIds, action },
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};
